<template>
      <v-menu offset-y nudge-width="350" eager :close-on-content-click="false">
        <template v-slot:activator="{on:columns}">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn icon small v-on="{...tooltip,...columns}"><v-icon v-on="columns">mdi-view-list</v-icon></v-btn>
            </template>
            Customize the list view
          </v-tooltip>
        </template>
        <v-card>
          <v-card-title>List columns to show</v-card-title>
          <v-list ref="columns" dense max-height="350px" class="overflow-y">
            <template v-for="column of columns">
              <v-list-item :key="column.value" class="draggable">
                <v-list-item-icon>
                  <v-icon class="handle">mdi-drag</v-icon>
                  <v-simple-checkbox v-model="column.visible" @input="save()"/>
                </v-list-item-icon>
                <v-list-item-title>{{headerForColumn(column)}}</v-list-item-title>
                <v-list-item-subtitle>
                  <v-slider thumb-size="10" hide-details dense v-model="column.size" max="50" :disabled="!column.visible" @change="save()"/>
                </v-list-item-subtitle>
              </v-list-item>
            </template>
          </v-list>
          <v-divider/>
          <v-card-actions>
            <v-btn plain @click="reset">Reset columns</v-btn>
            <v-spacer/>
            <v-switch label="Dense" v-model="dense"/>
            <v-spacer/>
            <v-switch label="Dividers" v-model="divider"/>
          </v-card-actions>
        </v-card>
      </v-menu>
</template>

<script>
import sortableJS from 'sortablejs';

export default {
  name: 'CustomizeTable',
  props: {
    name: {type:String, required:true},
    defaultColumns: {type:Array, required:true},
//    columns: {type:Array, required:true},
    headers: {type:Array, required:true}
  },
  data() {
    return {
      columns: [],
      dense: false,
      divider: false,
      sortable: null
    }
  },
  watch: {
    dense() {
      localStorage.setItem(`${this.name}.dense`, this.dense?'1':'0');
      this.$emit('update:dense', this.dense);
    },
    divider() {
      localStorage.setItem(`${this.name}.divider`, this.divider?'1':'0');
      this.$emit('update:divider', this.divider);
    }
  },
  created() {
    // If any columns are not in defined columns, remove them
    // This can occur if we delete columns that have been used
    this.columns = JSON.parse(localStorage.getItem(`${this.name}.columns`) || JSON.stringify(this.defaultColumns));
    if (this.columns.some(column => !this.defaultColumns.some(c => c.value === column.value)))
      this.reset();
    else
      this.sizeColumns();

    this.dense = localStorage.getItem(`${this.name}.dense`)==='1' || this.dense;
    this.divider = localStorage.getItem(`${this.name}.divider`)==='1' || this.divider;
  },
  mounted() {
    const _self = this;
    this.sortable = sortableJS.create(this.$refs.columns.$el, {
      handle: '.handle',
      draggable: '.draggable',
      onEnd({newIndex, oldIndex}) {
        const columnSelected = _self.columns.splice(oldIndex, 1)[0];
        _self.columns.splice(newIndex, 0, columnSelected);
        _self.save();
      }
    })
  },
  beforeDestroy() {
    this.sortable.destroy();
  },
  methods: {
    sizeColumns() {
      // Set default column sizes if not already set
      this.columns.forEach(column => {
        if (!column.size) {
          const header = this.headers.find(header => header.value === column.value);
          this.$set(column, 'size', parseInt(header.width));
        }
      });
      this.$emit('update:columns', this.columns);
    },
    reset() {
      localStorage.removeItem(`${this.name}.columns`);
      this.headers.forEach(header => header.width = header.originalWidth);
      this.columns = JSON.parse(JSON.stringify(this.defaultColumns));
      this.sizeColumns();
    },
    headerForColumn(column) {
      return this.headers.find(header => header.value === column.value).text;
    },
    save() {
      localStorage.setItem(`${this.name}.columns`, JSON.stringify(this.columns));
    }
  }
}
</script>